import type { PageType } from '@/types/models'
import { locationListIsInternational } from '../../location/useCases/computeLocationGroups'
import {
  isFacetPageType,
  isInsurancePage,
  isLocationPageType
} from '../pageTypeCheck'

const isNonInsuranceLocationOrFacet = (pageType: PageType) =>
  (isLocationPageType(pageType) || isFacetPageType(pageType)) &&
  !isInsurancePage(pageType)

export const shouldRenderInsuranceMiniCarousel = ({
  locationParts = [],
  pageType
}: {
  locationParts?: string[]
  pageType: PageType
}): boolean => {
  if (
    locationListIsInternational(locationParts) ||
    !isNonInsuranceLocationOrFacet(pageType)
  ) {
    return false
  }

  return true
}
